/*
 * @Author: zhenhui.duan
 * @Date: 2024-05-23 12:32:10
 * @Description:
 */
import URL from '../constants/URL';
import dataProxy from '../dataProxy';

export default {
  /**
   * 获取安全中心 信息
   * @returns {Promise<any>}
   */
  getSecurityInfo(params) {
    return dataProxy.get(URL.USER_SECURITY, { params });
  },
  getWithdrawLimit(params) {
    return dataProxy.get(URL.USER_WITHDRAW_LIMIT, { params });
  },
  getParameter(params) {
    return dataProxy.get(URL.GET_PARAMETER, { params });
  },
  /**
   * 获取是否设置提现额度 信息
   * @returns {Promise<any>}
   */
  getInfo(params1, params2) {
    const reqArr = [
      this.getSecurityInfo(params1),
      this.getWithdrawLimit(params2),
    ];
    return new Promise((resolve, reject) => {
      Promise.all(reqArr)
        .then((res) => {
          const info = res[0];
          const withdrawInfo = res[1];
          const obj = { info: info.data, withdrawInfo: withdrawInfo.data };
          resolve(obj);
        })
        .catch((err1, err2) => {
          reject(err1 || err2);
        });
    });
  },
};
